import { ACTION_TAB_DATA, ACTIVE_TAB } from "../../constants/ActionTypes";

const INIT_STATE = {
  activeTab: null,
  activeTabData: null,
};

const activeTabReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ACTIVE_TAB: {
      return {
        ...state,
        activeTab: action.payload,
      };
    }
    case ACTION_TAB_DATA: {
      return {
        ...state,
        actionTabData: action.payload,
      };
    }
    default:
      return state;
  }
};

export default activeTabReducer;
